import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import {RouterModule} from '@angular/router';
import {LocationStrategy, HashLocationStrategy, registerLocaleData} from '@angular/common';

import {ROUTES} from './app.routes';
import { AppComponent } from './app.component';

import { CanDeactivateGuard } from './shared/services/can-deactivate-guard.service';

// App views
import {AppviewsModule} from './views/appviews/appviews.module';

// App modules/components
import {LayoutsModule} from './components/common/layouts/layouts.module';
import { SharedModule } from './shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { AppConfig } from './app.config';
import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-snotify';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastaModule } from 'ngx-toasta';
import { DialogService } from './shared/services/dialog.service';
import localeMx from '@angular/common/locales/es-MX';
import { BnNgIdleService } from 'bn-ng-idle';
registerLocaleData(localeMx, 'es-MX');
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    LayoutsModule,
    AppviewsModule,
    HttpClientModule,
    SharedModule.forRoot(),
    RouterModule.forRoot(ROUTES, { onSameUrlNavigation: 'reload', useHash: false }),
    SnotifyModule,
    NgxSpinnerModule,
    ToastaModule.forRoot()
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    AppConfig,
    { provide: 'SnotifyToastConfig', useValue: ToastDefaults },
    SnotifyService,
    CanDeactivateGuard,
    DialogService,
    { provide: LOCALE_ID, useValue: 'es-MX' },
    BnNgIdleService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
